import React from 'react';
import PropTypes from 'prop-types';

import ClampedMultiLineText from 'dpl/common/components/ClampedMultiLineText';
import SmartLink from 'dpl/components/SmartLink';
import SmartImage from 'dpl/components/SmartImage';

export default function BreedDescriptionRelatedBreed({ breed }) {
  const {
    name: breedName,
    secondary_photo_url: secondaryPhotoUrl,
    url
  } = breed;

  return (
    <div className="BreederSearchResultsBreedDescriptionRelatedBreed br3 ba b--light-gray mt2 mr2 pv2 ph2 flex f2">
      <SmartLink className="inline-flex" to={url}>
        <div className="br2">
          <div className="transition grow f0 br2 overflow-hidden">
            <SmartImage
              Tag="div"
              crop
              lazy
              className="zoom cover"
              height="40px"
              src={secondaryPhotoUrl}
              width="40px"
            />
          </div>
        </div>
        <div className="flex items-center mh2">
          <ClampedMultiLineText
            className="mb1 mb0-lg f2 ws-normal fw-medium"
            text={breedName}
            hideEllipses
            numOfLines={2}
            lineHeight={21}
            displayMoreText={false}
          />
        </div>
      </SmartLink>
    </div>
  );
}

BreedDescriptionRelatedBreed.propTypes = {
  breed: PropTypes.shape({
    name: PropTypes.string.isRequired,
    secondary_photo_url: PropTypes.string,
    url: PropTypes.string
  }).isRequired
};
